import { render, staticRenderFns } from "./gameResultCockfightTab.vue?vue&type=template&id=2719d3d2&lang=pug"
import script from "./gameResultCockfightTab.vue?vue&type=script&lang=js"
export * from "./gameResultCockfightTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports